import { msg } from "@lingui/core/macro";

export const maxVehicleUsageInPeriodRuleMessages = {
	name: msg({ message: "Maximum Vehicles In Period" }),
	description: msg({ message: "Maximum Vehicles in a Period of Time" }),
	errors: {
		limitReachedDay: msg({
			message: "The limit of {amount} registration(s) within 1 day has been reached for {plates}.",
		}),
		limitReachedDays: msg({
			message: "The limit of {amount} registration(s) within {days} days has been reached for {plates}.",
		}),
		limitReachedWeek: msg({
			message: "The limit of {amount} registration(s) this week has been reached for {plates}.",
		}),
		limitReachedMonth: msg({
			message: "The limit of {amount} registration(s) this month has been reached for {plates}.",
		}),
		limitReachedNever: msg({ message: "The limit of {amount} registration(s) has been reached for {plates}." }),
	},
} as const;
